import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getPreventionOrder = (state: IRootState) => state.prevention.order;
export const getPreventionSearchValue = (state: IRootState) => state.prevention.searchValue;
export const getPreventionKnms = (state: IRootState) => state.prevention.data;
export const getPreventionPage = (state: IRootState) => state.prevention.page;
export const getPreventionPageCount = (state: IRootState) => state.prevention.pageCount;
export const getPreventionTotalCount = (state: IRootState) => state.prevention.totalCount;
export const getPreventionRejected = (state: IRootState) => state.prevention.rejected;
